import { useKpiBadgeColor } from '../../hooks';
import { StyledBadge } from './KpiBadge.styles';

export interface IStyledBadge {
  result: string;
}

export const KpiBadge = ({ result }: IStyledBadge) => {
  const color = useKpiBadgeColor(result);

  return <StyledBadge variant="dot" bgColor={color} />;
};
